import { TooltipLabel } from "./Tooltip";

export type MetricTone = "" | "metric-data" | "metric-active" | "metric-flag";

/** One label/value cell used in the student live writing summary grid. */
export function MetricItem({
  label,
  value,
  tone = "",
  tooltip,
}: {
  label: string;
  value: string;
  tone?: MetricTone;
  tooltip?: string;
}) {
  return (
    <div className={`metric-item ${tone}`.trim()}>
      {tooltip ? <TooltipLabel tooltip={tooltip}>{label}</TooltipLabel> : <span>{label}</span>}
      <strong>{value}</strong>
    </div>
  );
}
